module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDExIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjU2MTc3MyA0LjQzNDg2Qy0wLjExNjU0NiA1LjAxMjQzIDAuMzYzODY3IDYgMS4zMjMxNiA2SDkuODI5QzEwLjc4ODMgNiAxMS4yNjg3IDUuMDEyNDMgMTAuNTkwNCA0LjQzNDg2TDYuMzM3NDYgMC44MTM1NzhDNS45MTY5NiAwLjQ1NTUzIDUuMjM1MTkgMC40NTU1MyA0LjgxNDY5IDAuODEzNTc3TDAuNTYxNzczIDQuNDM0ODZaIiBmaWxsPSIjQURBREFEIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/arrow.svg
// module id = KPAv
// module chunks = 0